import request from "../utils/request";
//获取解锁方式列表
export function getLockList(params,number=1) {
    return request({
        url: `/lock/list?queryType=${number}&pageNum=${params.pageNum}&pageSize=${params.pageSize}&name=${params.name}&lockType=${params.lockType}`,
        method: "get"
    });
}

//更具id查询解锁方式信息
export function getLockListById(params) {
    return request({
        url: `/lock/getById?id=${params.id}`,
        method: "get"
    });
}

//删除解锁方式
export function deleteLockListById(params) {
    return request({
        url: `/lock/delete`,
        method: "post",
        data:{
            id:params.id
        }
    });
}

//修改解锁组

export function editLockList(params) {
    return request({
        url: `/lock/update`,
        method: "post",
        data:{
            lockCO:params
        }
        
    });
}

//新增解锁组
export function createLockList(params) {
    return request({
        url: `/lock/add`,
        method: "post",
        data:{
            lockCO:params
        }
    });
}

//获取解锁方式类型
export function getLockMode() {
    return request({
        url: `/lockGroup/listTypes`,
        method: "get"
    });
}